import React, { Component } from 'react'
import { Grid, Image, Header, Button, Divider } from 'semantic-ui-react'
import '../styles/product-card.css'
import ProductQuickView from './ProductQuickView'
export default class ProductCard extends Component {
  state = {
    selectedSize: null,
    toggleQuickView: false
  }
  selectSize(id) {
    this.setState({
      selectedSize: id
    })
  }
  toggleQuickView() {
    this.setState({
      toggleQuickView: !this.state.toggleQuickView
    })
  }
  addToCart(e, data, qty = 1) {
    this.props.addToCart(this.state.selectedSize, qty)
    this.setState({
      selectedSize: null
    })
  }

  render() {
    const {
      images,
      name,
      description,
      v_productVariants: variants
    } = this.props.product
    const instock =
      variants.reduce((acc, val) => acc + val.virtualinstock, 0) > 0
    return (
      <Grid.Column mobile={8} tablet={8} computer={4} className="product-card">
        <ProductQuickView
          selectedSize={this.state.selectedSize}
          selectSize={this.selectSize.bind(this)}
          addToCart={this.addToCart.bind(this)}
          toggleQuickView={this.toggleQuickView.bind(this)}
          visible={this.state.toggleQuickView}
          product={this.props.product}
          sizeGuide={this.props.sizeGuide}
        />
        <div className="product-card-image">
          <Image
            fluid
            src={`/storage/${images[0]}`}
            style={{ marginBottom: 10 }}
            onClick={this.toggleQuickView.bind(this)}
            label={
              !instock
                ? { as: 'a', color: 'red', ribbon: 'left', icon: 'dont' }
                : null
            }
          />

          <div className="product-card-controls">
            <Button
              color="black"
              fluid
              basic
              onClick={this.toggleQuickView.bind(this)}
            >
              Quick View
            </Button>
            <br />
            <strong>Sizes</strong>
            <Divider style={{ margin: '0.5em' }} />
            {variants.sort((a, b) => a.sortOrder - b.sortOrder).map(variant =>
              <Button
                key={variant.id}
                disabled={!(variant.virtualinstock > 0)}
                color={this.state.selectedSize !== variant.id ? 'grey' : 'red'}
                basic={this.state.selectedSize !== variant.id}
                circular
                size="tiny"
                style={{
                  borderRadius: '50%',
                  height: '30px',
                  width: '30px',
                  textAlign: 'center',
                  padding: 0
                }}
                onClick={() => this.selectSize(variant.id)}
              >
                {variant.size}
              </Button>
            )}
            <Divider style={{ margin: '0.5em' }} />
            <Button
              fluid
              color="red"
              onClick={this.addToCart.bind(this)}
              disabled={this.state.selectedSize === null}
              content={
                this.state.selectedSize === null
                  ? 'Select a Size'
                  : 'Add to Bag'
              }
            />
          </div>
        </div>
        <Header as="h4" style={{ marginTop: 10 }}>
          {name}
          <Header.Subheader>
            {description}
          </Header.Subheader>
        </Header>
      </Grid.Column>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ProductCard.jsx